const quickViewImageCache = new Map();
const quickViewProductCache = new Map();
const QUICK_VIEW_DEFAULT_QUANTITY = 4;

// Produse cu limita pe client: in Quick View nu se pot adauga, clientul e trimis pe pagina produsului,
// unde tema calculeaza cat i-a mai ramas din comenzile anterioare.
const QUICK_VIEW_LIMITED_SKUS = ['6298043161978'];

let quickViewLastFocusedElement = null;

function getShopifyRootUrl() {
  return window.Shopify?.routes?.root || '/';
}

function isCustomerLoggedIn() {
  return !!window.ShopifyAnalytics?.meta?.page?.customerId;
}

function initQuickViewButtons(scope = document) {
  scope.querySelectorAll('.card-gallery').forEach((gallery) => {
    if (gallery.querySelector('.quick-view-btn')) return;

    const btn = document.createElement('button');
    btn.className = 'quick-view-btn';
    btn.type = 'button';
    btn.textContent = 'Quick View';
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.setAttribute('aria-controls', 'quick-view-modal');
    gallery.appendChild(btn);
  });
}

function ensureQuickViewModal() {
  let modal = document.getElementById('quick-view-modal');
  if (modal) return modal;

  modal = document.createElement('div');
  modal.id = 'quick-view-modal';
  modal.className = 'quick-view-modal';
  modal.setAttribute('aria-hidden', 'true');
  modal.innerHTML = `
    <div class="quick-view-modal__overlay"></div>
    <div
      class="quick-view-modal__dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="qv-title"
    >
      <button type="button" class="quick-view-modal__close" aria-label="Close quick view">\xD7</button>
      <div class="quick-view-modal__content">
        <p class="qv-loading">Loading...</p>
      </div>
    </div>
  `;
  document.body.appendChild(modal);
  return modal;
}

function getProductHandleFromButton(button) {
  const container = button.closest('.product-card, .card, li, .grid__item');
  if (!container) return null;

  const link = container.querySelector('a[href*="/products/"]');
  if (!link) return null;

  const href = link.getAttribute('href');
  return href ? href.split('/products/')[1]?.split('?')[0]?.split('#')[0] : null;
}

function formatPrice(price) {
  return new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency',
    currency: 'EUR',
  }).format((price || 0) / 100);
}

function stripHtml(html) {
  const el = document.createElement('div');
  el.innerHTML = html;
  return el.textContent || '';
}

function escapeHtml(value) {
  return String(value || '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

function truncate(text, len = 200) {
  return text.length <= len ? text : text.slice(0, len).trimEnd() + '...';
}

function getQuantityOptions() {
  return [4, 6, 12, 18, 24, 36, 48, 96, 144, 192, 240, 288, 384, 480, 768, 960];
}

function buildQuantitySelect() {
  return `
    <select id="qv-quantity" name="quantity" aria-label="Quantity">
      ${getQuantityOptions()
        .map(
          (quantity) =>
            `<option value="${quantity}"${quantity === QUICK_VIEW_DEFAULT_QUANTITY ? ' selected' : ''}>${quantity}</option>`
        )
        .join('')}
    </select>
  `;
}

/**
 * Daca varianta e deja in cos, ii seteaza cantitatea aleasa in loc sa o adune peste (4 + 4 + 12 ar da 20),
 * la fel ca butonul din pagina produsului.
 */
async function addToCart(variantId, quantity) {
  const rootUrl = getShopifyRootUrl();

  const currentCartResponse = await fetch(`${rootUrl}cart.js`, { headers: { Accept: 'application/json' } });
  if (!currentCartResponse.ok) throw new Error('Cart error');
  const currentCart = await currentCartResponse.json();
  const existingItem = currentCart.items.find((item) => item.variant_id === Number(variantId));

  let response;
  if (existingItem) {
    response = await fetch(`${rootUrl}cart/change.js`, {
      method: 'POST',
      body: JSON.stringify({ id: existingItem.key, quantity }),
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    });
  } else {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    response = await fetch(`${rootUrl}cart/add.js`, {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' },
    });
  }

  if (!response.ok) throw new Error('Cart error');

  const cartResponse = await fetch(`${rootUrl}cart.js`, { headers: { Accept: 'application/json' } });
  if (!cartResponse.ok) throw new Error('Cart refresh error');

  const cart = await cartResponse.json();
  document.dispatchEvent(
    new CustomEvent('cart:update', {
      bubbles: true,
      detail: { data: cart, source: 'quick-view' },
    })
  );
  return cart;
}

function preloadImage(src) {
  if (!src || quickViewImageCache.has(src)) return;

  const img = new Image();
  img.src = src;
  quickViewImageCache.set(src, true);
}

async function getProductData(handle) {
  if (quickViewProductCache.has(handle)) return quickViewProductCache.get(handle);

  const response = await fetch(`${getShopifyRootUrl()}products/${handle}.js`);
  if (!response.ok) throw new Error('Product load error');

  const product = await response.json();
  quickViewProductCache.set(handle, product);
  if (product.images?.length) preloadImage(product.images[0]);
  return product;
}

function renderQuickViewContent(product, handle) {
  const image = product.images?.[0] || '';
  const title = product.title || '';
  const description = truncate(stripHtml(product.description || ''));
  const selectedVariant = product.variants?.find((variant) => variant.available) || product.variants?.[0];
  const variantId = selectedVariant?.id || '';
  const price = formatPrice(selectedVariant?.price ?? product.price ?? 0);
  const productUrl = `${getShopifyRootUrl()}products/${handle}`;
  const isAvailable = !!(selectedVariant?.available && variantId);
  const isLimited = (product.variants || []).some((variant) => QUICK_VIEW_LIMITED_SKUS.includes(variant.sku));

  let actions;
  if (!isCustomerLoggedIn()) {
    actions = `
      <a href="${getShopifyRootUrl()}account/login" class="qv-add">
        Log in to purchase
      </a>
    `;
  } else if (isLimited) {
    actions = `
      <p class="qv-limit-note">
        Maximum 144 pieces per customer. Please order this product from its product page.
      </p>
    `;
  } else {
    actions = `
      <div class="qv-qty">
        <label for="qv-quantity">Quantity</label>
        ${buildQuantitySelect()}
      </div>

      <button class="qv-add" data-id="${variantId}"${isAvailable ? '' : ' disabled'}>
        ${isAvailable ? 'Add to Cart' : 'Sold Out'}
      </button>

      <button class="qv-buy" data-id="${variantId}"${isAvailable ? '' : ' disabled'}>
        ${isAvailable ? 'Buy Now' : 'Unavailable'}
      </button>
    `;
  }

  return `
    <div class="qv-product">
      ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(title)}" class="qv-image" loading="eager" fetchpriority="high">` : ''}

      <h3 id="qv-title" class="qv-title">${escapeHtml(title)}</h3>
      <div class="qv-price">${escapeHtml(price)}</div>
      ${description ? `<p class="qv-desc">${escapeHtml(description)}</p>` : ''}

      ${actions}

      <a href="${escapeHtml(productUrl)}" class="qv-details-link">
        View Full Details
      </a>
    </div>
  `;
}

async function openQuickView(handle, triggerButton) {
  const modal = ensureQuickViewModal();
  const content = modal.querySelector('.quick-view-modal__content');

  quickViewLastFocusedElement = triggerButton || document.activeElement;
  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.classList.add('quick-view-open');
  content.innerHTML = '<p class="qv-loading">Loading...</p>';

  requestAnimationFrame(() => {
    modal.querySelector('.quick-view-modal__close')?.focus();
  });

  try {
    const product = await getProductData(handle);
    content.innerHTML = renderQuickViewContent(product, handle);
  } catch {
    content.innerHTML = '<p class="qv-error">Failed to load product.</p>';
  }
}

function closeQuickView() {
  const modal = document.getElementById('quick-view-modal');
  if (!modal) return;

  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('quick-view-open');

  if (quickViewLastFocusedElement instanceof HTMLElement) quickViewLastFocusedElement.focus();
}

function warmUpQuickViewFromGallery(gallery) {
  if (!gallery) return;

  const button = gallery.querySelector('.quick-view-btn');
  if (!button) return;

  const handle = getProductHandleFromButton(button);
  if (handle) getProductData(handle).catch(() => {});
}

document.addEventListener('DOMContentLoaded', () => {
  initQuickViewButtons();
  ensureQuickViewModal();

  // pointerenter/focusin in faza de capturare ajung si cu target = document, care nu are closest()
  document.addEventListener(
    'pointerenter',
    (event) => {
      if (!(event.target instanceof Element)) return;
      const gallery = event.target.closest('.card-gallery');
      if (gallery) warmUpQuickViewFromGallery(gallery);
    },
    true
  );

  document.addEventListener(
    'focusin',
    (event) => {
      if (!(event.target instanceof Element)) return;
      const gallery = event.target.closest('.card-gallery');
      if (gallery) warmUpQuickViewFromGallery(gallery);
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeQuickView();
  });

  document.addEventListener(
    'click',
    async (event) => {
      if (!(event.target instanceof Element)) return;

      const quickViewButton = event.target.closest('.quick-view-btn');
      if (quickViewButton) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const handle = getProductHandleFromButton(quickViewButton);
        if (!handle) {
          alert('Product not found');
          return;
        }

        openQuickView(handle, quickViewButton);
        return;
      }

      if (
        event.target.closest('.quick-view-modal__close') ||
        event.target.classList.contains('quick-view-modal__overlay')
      ) {
        event.preventDefault();
        closeQuickView();
        return;
      }

      const addButton = event.target.closest('button.qv-add');
      if (addButton && !addButton.disabled) {
        event.preventDefault();

        const quantitySelect = document.getElementById('qv-quantity');
        const quantity = Number(quantitySelect?.value || QUICK_VIEW_DEFAULT_QUANTITY);
        const variantId = addButton.dataset.id;
        const originalText = addButton.textContent;

        try {
          addButton.disabled = true;
          await addToCart(variantId, quantity);
          addButton.textContent = 'Added';
          addButton.classList.add('is-added');

          setTimeout(() => {
            addButton.disabled = false;
            addButton.textContent = originalText;
            addButton.classList.remove('is-added');
          }, 1200);
        } catch {
          addButton.disabled = false;
          addButton.textContent = 'Error';
          setTimeout(() => {
            addButton.textContent = originalText;
          }, 1200);
        }
        return;
      }

      const buyButton = event.target.closest('.qv-buy');
      if (buyButton && !buyButton.disabled) {
        event.preventDefault();

        const quantitySelect = document.getElementById('qv-quantity');
        const quantity = Number(quantitySelect?.value || QUICK_VIEW_DEFAULT_QUANTITY);
        const variantId = buyButton.dataset.id;
        const originalText = buyButton.textContent;

        try {
          buyButton.disabled = true;
          await addToCart(variantId, quantity);
          window.location.href = `${getShopifyRootUrl()}checkout`;
        } catch {
          buyButton.disabled = false;
          buyButton.textContent = 'Error';
          setTimeout(() => {
            buyButton.textContent = originalText;
          }, 1200);
        }
        return;
      }
    },
    true
  );

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches?.('.card-gallery')) {
          initQuickViewButtons(node.parentNode || document);
          return;
        }

        if (node.querySelector?.('.card-gallery')) initQuickViewButtons(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
});
